<template>
  <div class="articlemanagement">
    <Row type="flex" justify="center" align="top" class="code-row-bg">
      <Col span="16">
      <Card :style="'margin-right: 5px;height:' + (height + 120) + 'px'">
        <!--:is="defaultMap"-->
        <component
          is="leaflet"
          ref="mapCase"
          :color="areaColorList"
          :saveForm="saveForm"
          :collectPreview="collectPreview"
          :collectPreviewEditingLocked="collectPreviewEditingLocked"
          :collectPreviewHasUnsavedChanges="collectPreviewHasUnsavedChanges"
          @saveOne="saveOne"
          @collectPreviewEdited="handleCollectPreviewEdited"
          @saveCollectPreview="saveCollectPreviewFromMap"
          @cancelCollectPreviewEdits="cancelCollectPreviewEditsFromMap"
          @cancelCollectPreview="cancelCollectPreview"
          @updateAreaList="updateAreaList"
          @editState="editFence"
          @refreshData="handleRefreshData"
          @activeFenceChanged="handleActiveFenceChanged"
          @unsavedChangesChanged="handleUnsavedChangesChanged"
          @areasRenderStart="handleAreasRenderStart"
          @areasRendered="handleAreasRendered"
        >
          <div class="leaflet" :style="'height:' + (height + 90) + 'px'">
            <div id="enclosure_map_id" ref="map" class="map"></div>
          </div>
        </component>
      </Card>
      </Col>
      <Col span="8">
      <div class="nodeArea">
        <Card :bordered="false">
          <div slot="title">
            <Row>
              <Col :xs="24" :sm="24">
              <Form :label-width="80">
                <div class="des-cardTittle-box">
                  <h3>{{langMap.fenceManage[lang]}}</h3>
                  <div>
                    <Button type="primary" style="margin-left:20px;" :disabled="hasAnyUnsavedChanges" @click="modelShow(true, null)">{{langMap.add[lang]}}</Button>
                    <Button type="primary" style="margin-left:20px;" @click="editFence()">
                      {{ this.isEdit ? langMap.cancelEdit[lang] : langMap.editArea[lang] }}
                    </Button>
                  </div>
                </div>
              </Form>
              </Col>
            </Row>
          </div>
          <!-- 修改表格，添加ref引用以便操作DOM -->
          <Table ref="fenceTable" :height="height" :loading="tableLoading" border :columns="col" :data="displayAreaList"
            @on-row-click="rowClick" :row-class-name="rowClassName" :span-method="spanMethod">
          </Table>
        </Card>

        <!-- 组件的对话框 :rules="ruleValidate"-->
        <Modal :mask-closable="false" v-model="saveModal" :title="langMap.electronicFence[lang]" class-name="fence-edit-modal">
          <Form ref="formValidate" :model="saveForm" :label-width="80">
            <FormItem :label="langMap.name[lang]" prop="name" :rules="ruleValidate.name">
              <Input v-model="saveForm.name" :placeholder="langMap.inputName[lang]" clearable />
            </FormItem>
            <!--NEW ADD-->
            <FormItem :label="langMap.belongStation[lang]" prop="stationId" :rules="ruleValidate.stationId">
              <Select v-model="saveForm.stationId" :placeholder="langMap.pleaseSelect[lang]">
                <Option v-for="item in stationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="langMap.layerPriority[lang]" prop="layerPriority" :rules="ruleValidate.layerPriority">
              <Select v-model="saveForm.layerPriority" :placeholder="langMap.pleaseSelect[lang]">
                <Option :value="0">0</Option>
                <Option :value="1">1</Option>
                <Option :value="2">2</Option>
                <Option :value="3">3</Option>
              </Select>
            </FormItem>
            <FormItem :label="langMap.type[lang]" class="leftFlex" prop="type">
              <Select v-model="saveForm.type">
                <Option :key="item.id" :value="item.id" v-for="item in areaTypeList">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="langMap.description[lang]">
              <Input v-model="saveForm.description" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }"
                :placeholder="langMap.descInfo[lang]" />
            </FormItem>
            <FormItem :label="langMap.area[lang]">
              <div class="copy-area-container">
                <Input
                  v-model="saveForm.area"
                  disabled
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 8 }"
                  class="scrollable-textarea"
                />
                <Button
                  size="small"
                  type="text"
                  icon="ios-copy"
                  class="copy-btn"
                  :title="langMap.copy[lang]"
                  @click="copyToClipboard(saveForm.area)"
                  v-if="saveForm.area"
                ></Button>
              </div>
            </FormItem>
            <FormItem :label="langMap.originalArea[lang]" v-if="saveForm.id">
              <div class="copy-area-container">
                <Input
                  v-model="saveForm.originalArea"
                  disabled
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 8 }"
                  class="scrollable-textarea"
                />
                <Button
                  size="small"
                  type="text"
                  icon="ios-copy"
                  class="copy-btn"
                  :title="langMap.copy[lang]"
                  @click="copyToClipboard(saveForm.originalArea)"
                  v-if="saveForm.originalArea"
                ></Button>
              </div>
            </FormItem>
            <FormItem :label="langMap.isCollect[lang]" v-if="!saveForm.id">
              <div class="fill-item">
                <RadioGroup v-model="saveForm._isFill" @on-change="fillChange">
                  <Radio :label="langMap.no[lang]"></Radio>
                  <Radio :label="langMap.yes[lang]"></Radio>
                </RadioGroup>
                <fileSelect v-show="saveForm._isFill === langMap.yes[lang]" style="margin-left: 30px;" class="file-box-unit"
                  @change="fileChange" />
                <span v-show="saveForm._isFill === langMap.yes[lang]" style="font-size: 12px;color:#87888a;">（{{langMap.supportFiles[lang]}}）</span>
              </div>
            </FormItem>
            <FormItem :label="langMap.collectData[lang]" v-if="saveForm._isFill === langMap.yes[lang]" v-show="!saveForm.id"
              :rules="ruleValidate.collectImportArea" prop="collectImportArea">
              <Input v-model="saveForm.collectImportArea" :placeholder="importPlaceHolder" type="textarea"
                class="scrollbar-g" :autosize="{ minRows: 4, maxRows: 8 }" />
            </FormItem>
            <div v-if="saveForm._isFill === langMap.yes[lang]" v-show="!saveForm.id" style="margin-top: 10px;margin-left: 80px;padding: 10px;border: 1px solid #e8eaec;border-radius: 4px;">
              <div
                style="font-size: 12px;color: #87888a;cursor: pointer;display:flex;align-items:center;justify-content:space-between;user-select:none;"
                @click="showGenerateAreaPanel = !showGenerateAreaPanel"
              >
                <span>{{ langMap.generateAreaFromCollectPoints[lang] }}</span>
                <Icon :type="showGenerateAreaPanel ? 'ios-arrow-up' : 'ios-arrow-down'" style="font-size:14px;" />
              </div>
              <div v-show="showGenerateAreaPanel" style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-top: 10px;">
                <div style="display:flex;align-items:center;gap:6px;">
                  <span style="font-size: 12px;color:#515a6e;">{{ langMap.expandDistance[lang] }}</span>
                  <InputNumber v-model="collectBufferDistanceM" :min="0.1" :step="0.1" style="width: 110px;" />
                </div>
                <div style="display:flex;align-items:center;gap:6px;">
                  <span style="font-size: 12px;color:#515a6e;">{{ langMap.cornerStyle[lang] }}</span>
                  <Select v-model="collectBufferJoinStyle" style="width: 120px;" @on-change="handleCollectJoinStyleChange">
                    <Option value="round">{{ langMap.cornerRound[lang] }}</Option>
                    <Option value="miter">{{ langMap.cornerMiter[lang] }}</Option>
                  </Select>
                </div>
                <div v-if="collectBufferJoinStyle === 'round'" style="display:flex;align-items:center;gap:6px;">
                  <span style="font-size: 12px;color:#515a6e;">{{ langMap.bufferResolution[lang] }}</span>
                  <InputNumber v-model="collectBufferResolution" :min="4" :step="1" style="width: 110px;" />
                </div>
                <Button size="small" type="primary" @click="generateCollectAreaFromPoints">{{ langMap.generateArea[lang] }}</Button>
              </div>
            </div>
            <div v-if="saveForm._isFill === langMap.yes[lang]" v-show="!saveForm.id" style="margin-top: 10px;margin-left: 80px;">
              <Button
                type="primary"
                size="small"
                :loading="collectPreviewEditingLocked"
                @click="previewCollectFence"
              >{{ langMap.preview[lang] }}</Button>
              <Button
                v-show="collectPreview.active"
                size="small"
                style="margin-left: 10px;"
                :disabled="collectPreviewEditingLocked"
                @click="cancelCollectPreview"
              >{{ langMap.cancelPreview[lang] }}</Button>
            </div>
          </Form>
          <div slot="footer">
            <Button type="text" :loading="btnLoading" @click="cancel">{{langMap.cancel[lang]}}</Button>
            <Button type="primary" :loading="btnLoading" @click="save">{{langMap.save[lang]}}</Button>
          </div>
        </Modal>
      </div>
      </Col>
    </Row>
    <Spin fix v-if="pageLoading">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>{{ isCollectPreviewRendering ? langMap.collectDataRendering[lang] : (isRerenderingFence ? langMap.fenceRecalcRendering[lang] : langMap.loading[lang]) }}</div>
    </Spin>
  </div>
</template>
<script>
import leaflet from './mapUnit/leaflet.vue';
import api from "../../../api";
import { readJsonFile } from '@/utils/index.js';
import langMap from '@/utils/language';
import ClipperLib from 'clipper-lib';
import { mapState } from 'vuex';
import { t } from '@/utils/language';


let mapCase = null;
const validStation = (rule, value, callback,language) => {
  if (!value && value !== 0) {
    callback(new Error(langMap.stationRequired[language]));
  } else {
    callback();
  }
};
// 导入数据校验
const validAreaData = (rule, value, callback,language) => {
  if (!value) {
    callback(new Error(langMap.collectDataRequired[language]));
  } else {
    try {
      console.log('*****value*****', value);
      const collectImportArea = JSON.parse(value);
      if(collectImportArea.length < 3){
        return callback(new Error(langMap.collectionDataRequired[language]));
      }
      callback();
    } catch (er) {
      callback(new Error(langMap.jsonFormatError[language]));
    }

  }
}
// 添加优先级验证函数
const validLayerPriority = (rule, value, callback, language) => {
  // 特别检查值为0的情况，因为0在JavaScript中是falsy值
  if (value === null || value === undefined || value === '') {
    callback(new Error(langMap.layerPriorityRequired[language]));
  } else {
    callback();
  }
};
// 表单初始化
function initSaveForm() {
  return {
    id: null,
    tempId: null,
    name: "",
    type: 1,
    typeStr: "",
    coordinateType: "WGS",
    area: null,
    description: "",
    stationId: "",
    layerPriority: null,
    _isFill: t('no'),
    isCollectImport: false, // 是否采集
    collectImportArea: '', // 采集数据字段
  };
}
const importPlaceHolder = `[
    {
        "lat":30.262776,
        "lng":120.123748
    },
    {
        "lat":30.262776,
        "lng":120.123748
    },
    {
        "lat":30.262776,
        "lng":120.123748
    }
]`;

export default {
  name: "ElectronicFence",
  components: {
    leaflet,
    fileSelect: () => import('@/components/fileSelect/index.vue')
  },
  data() {
    return {
      // 语言包映射
      langMap:langMap,
      // POI 搜索实例
      placeSearch: null,
      // 页面高度（用于地图/列表布局）
      height: document.documentElement.clientHeight - 260,
      // 地图实例引用
      map: null,
      // 采集导入占位示例
      importPlaceHolder,
      // 围栏类型列表
      areaTypeList: [],
      // 电子围栏图层集合
      areaLayers: [],
      // 电子围栏编辑图层集合
      areaEditLayers: [],
      // 电子围栏数据列表
      areaList: [],
      // 当前操作的图层引用
      currentLayer: null,
      // 按钮 loading 状态
      btnLoading: false,
      // 新增/编辑弹窗显示状态
      saveModal: false,
      // 是否处于编辑模式
      isEdit: false,
      // 表格 loading 状态
      tableLoading: false,
      // 地图是否存在未保存更改
      hasUnsavedMapChanges: false, // 跟踪地图是否有未保存的更改
      // 地图加载状态
      mapLoading: true,
      // 围栏图层是否渲染完成
      fencesRendered: false,
      // 表格是否渲染完成
      tableRendered: false,
      // 是否正在强制重渲染围栏（用于加载遮罩）
      isRerenderingFence: false,
      // 是否正在渲染采集预览（用于加载遮罩）
      isCollectPreviewRendering: false,
      // 归属点列表
      stationList: [],
      // 围栏表单数据
      saveForm:initSaveForm(),
      // 当前正在编辑的围栏 ID（用于表格行高亮/滚动定位）
      activeEditFenceId: null,
      // 采集预览状态（草稿围栏）
      collectPreview: {
        active: false,
        id: '__collect_preview__',
        latlngs: []
      },
      // 采集预览编辑锁（避免并发更新）
      collectPreviewEditingLocked: false,
      // 采集预览是否存在未保存更改
      collectPreviewHasUnsavedChanges: false,
      // 采集预览稳定坐标缓存（用于恢复/对比）
      collectPreviewStableLatLngs: [],
      // 采集预览稳定输入缓存（用于恢复/对比）
      collectPreviewStableImportArea: '',
      // 进入采集预览前的编辑模式快照
      collectPreviewEntryIsEdit: null,
      // 采集缓冲距离（米）
      collectBufferDistanceM: 1.0,
      // 采集缓冲拐角样式（round/miter）
      collectBufferJoinStyle: 'miter',
      // 圆角缓冲分辨率（仅 round 生效）
      collectBufferResolution: null,
      // 生成采集区域面板是否展开
      showGenerateAreaPanel: false,
    };
  },
  computed: {
    ...mapState({
        lang: state => state.app.language,
        areaColorList: state => state.app.mapAreaColor,
    }),
    pageLoading() {
      const value = this.mapLoading || this.tableLoading || !this.fencesRendered || !this.tableRendered;
      console.log(value)
      return this.mapLoading || this.tableLoading || !this.fencesRendered || !this.tableRendered;
    },
    hasAnyUnsavedChanges() {
      return !!(this.hasUnsavedMapChanges || this.collectPreviewHasUnsavedChanges);
    },
    ruleValidate(){
      return {
        name: [{ required: true, message: langMap.nameRequired[this.lang], trigger: "blur" }],
        stationId: [{ required: true, validator: (rule, value, callback) => validStation(rule, value, callback, this.lang), trigger: 'change' }],
        layerPriority: [{ required: true, validator: (rule, value, callback) => validLayerPriority(rule, value, callback, this.lang), trigger: 'change' }],
        collectImportArea: [{ required: true, validator: (rule, value, callback) => validAreaData(rule, value, callback, this.lang), trigger: 'blur' }]
      }
    },
    displayAreaList() {
      if (!this.collectPreview.active) return this.areaList;
      const station = this.stationList.find(s => s.id === this.saveForm.stationId);
      const draftRow = {
        id: null,
        tempId: this.collectPreview.id,
        isDraft: true,
        name: this.saveForm.name || this.langMap.unsaved[this.lang],
        type: this.saveForm.type,
        typeStr: this.saveForm.typeStr,
        stationId: this.saveForm.stationId,
        stationName: (station && station.name) || '',
        layerPriority: this.saveForm.layerPriority,
        area: null,
        description: this.saveForm.description
      };
      const list = Array.isArray(this.areaList) ? this.areaList : [];
      return [...list, draftRow];
    },
    col() {
      return [
        {
          title: langMap.name[this.lang],
          key: "name",
          render: (h, { row }) => {
            if (row && row.isDraft) {
              return h("div", { class: "text-ellipsis-3", attrs: { title: row.name } }, [
                h("Tag", { props: { color: "orange" }, style: { marginRight: "6px" } }, this.langMap.unsaved[this.lang]),
                h("span", row.name)
              ]);
            }
            return h("div", {
              class: "text-ellipsis-3",
              attrs: {
                title: row.name
              }
            }, row.name);
          }
        },
        {
          title: langMap.type[this.lang],
          key: "type",
          render: (h, { row }) => {
            let text = row.type;
            this.areaTypeList.forEach((item) => {
              if (item.id == row.type) {
                text = item.name;
              }
            });
            return h("span", text);
          }
        },
        {
          title: langMap.belongStation[this.lang],
          key: "stationName",
          render: (h, { row }) => {
            return h("span", row.stationName);
          }
        },
        {
          title: langMap.operation[this.lang],
          align: "center",
          render: (h, params) => {
            if (params.row && params.row.isDraft) {
              const renderArray = [];
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      disabled: this.hasUnsavedMapChanges
                    },
                    style: {
                      padding: "0px",
                      color: this.hasUnsavedMapChanges ? "#c5c8ce" : "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        if (this.hasUnsavedMapChanges) {
                          this.$Notice.warning({
                            title: langMap.tip[this.lang],
                            desc: langMap.pleaseFinishCurrentEdit[this.lang]
                          });
                          return;
                        }
                        this.showCollectDraftForm();
                      }
                    }
                  },
                  langMap.edit[this.lang]
                )
              );
              renderArray.push(
                h("Divider", {
                  props: { type: "vertical" },
                  style: { margin: "0 2px" }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: { type: "text" },
                    style: { padding: "0px", color: "#19be6b" },
                    on: {
                      click: (e) => {
                        e && e.stopPropagation();
                        this.saveCollectPreviewFromMap();
                      }
                    }
                  },
                  langMap.save[this.lang]
                )
              );
              renderArray.push(
                h("Divider", {
                  props: { type: "vertical" },
                  style: { margin: "0 2px" }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                    disabled: this.hasAnyUnsavedChanges
                    },
                    style: {
                      padding: "2px",
                    color: this.hasAnyUnsavedChanges ? "#c5c8ce" : "#2d8cf0"
                    },
                    on: {
                      click: (e) => {
                        e && e.stopPropagation();
                      if (this.hasAnyUnsavedChanges) {
                          this.$Notice.warning({
                            title: langMap.tip[this.lang],
                            desc: langMap.pleaseFinishCurrentEdit[this.lang]
                          });
                          return;
                        }
                        this.cancelCollectPreview();
                      }
                    }
                  },
                  this.langMap.remove[this.lang]
                )
              );
              return h("div", renderArray);
            }
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    disabled: this.hasAnyUnsavedChanges
                  },
                  style: {
                    padding: "0px",
                    color: this.hasAnyUnsavedChanges ? "#c5c8ce" : "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      if (this.hasAnyUnsavedChanges) {
                        this.$Notice.warning({
                          title: langMap.tip[this.lang],
                          desc: langMap.pleaseFinishCurrentEdit[this.lang]
                        });
                        return;
                      }
                      // params.row
                      this.modelShow(true, params.row);
                    }
                  }
                },
                langMap.edit[this.lang]
              )
            );
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    disabled: this.hasUnsavedMapChanges
                  },
                  style: {
                    padding: "2px",
                    color: this.hasUnsavedMapChanges ? "#c5c8ce" : "#2d8cf0"
                  },
                  on: {
                    click: (e) => {
                      e && e.stopPropagation();

                      if (this.hasUnsavedMapChanges) {
                        this.$Notice.warning({
                          title: langMap.tip[this.lang],
                          desc: langMap.pleaseFinishCurrentEdit[this.lang]
                        });
                        return;
                      }

                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmDelete[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "task-server/fence/delete/" + params.row.id,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.loadAreas(null,this.activeEditFenceId === params.row.id);
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            );
            if (!params.row.area || params.row.area === null) {
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    style: {
                      padding: "2px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: (e) => {
                        e && e.stopPropagation(); // 阻止事件冒泡
                        if(this.isEdit){
                          this.drawFence(params.row);
                        }else{
                          this.$Notice.warning({
                            title: langMap.tip[this.lang],
                            desc: langMap.pleaseClickEditAreaButton[this.lang]
                          });
                        }
                      }
                    }
                  },
                  langMap.draw[this.lang]
                )
              );
            }
            return h("div", renderArray);
          }
        }
      ]
    }
  },
  methods: {
    spanMethod(row, column, rowIndex) {
      if (!column || column.key !== 'stationName') return;
      const text = (row && row.stationName) == null ? '' : String(row.stationName);
      if (!text) return;

      const data = Array.isArray(this.displayAreaList) ? this.displayAreaList : [];
      const prev = data[rowIndex - 1];
      const prevText = prev && prev.stationName != null ? String(prev.stationName) : '';
      if (rowIndex > 0 && prevText === text) {
        return { rowspan: 0, colspan: 0 };
      }

      let rowspan = 1;
      for (let i = rowIndex + 1; i < data.length; i++) {
        const curText = data[i] && data[i].stationName != null ? String(data[i].stationName) : '';
        if (curText === text) rowspan++;
        else break;
      }
      return { rowspan, colspan: 1 };
    },
    mergeStationNameCells() {
      try {
        const colIndex = (this.col || []).findIndex(c => c && c.key === 'stationName');
        if (colIndex < 0) return;

        const tableRef = this.$refs.fenceTable;
        const tableEl = tableRef && tableRef.$el;
        if (!tableEl) return;

        const tbody = tableEl.querySelector('.ivu-table-body tbody');
        if (!tbody) return;

        const rows = tbody.querySelectorAll('tr');
        if (!rows || !rows.length) return;

        let lastText = null;
        let lastCell = null;
        let spanCount = 0;

        rows.forEach(tr => {
          const tds = tr && tr.children;
          const cell = tds && tds[colIndex];
          if (!cell) return;

          const text = (cell.innerText || '').trim();
          if (!text) {
            lastText = null;
            lastCell = null;
            spanCount = 0;
            return;
          }

          if (lastText === text && lastCell) {
            spanCount += 1;
            lastCell.setAttribute('rowspan', String(spanCount));
            cell.style.display = 'none';
          } else {
            lastText = text;
            lastCell = cell;
            spanCount = 1;
            cell.style.display = '';
            cell.setAttribute('rowspan', '1');
          }
        });
        
        // 合并完成后，更新高亮状态和绑定 hover 事件
        this.updateStationCellHighlight();
        this.bindTableRowHoverEvents();
      } catch (e) {
      }
    },
    // 更新归属站点单元格的高亮状态
    updateStationCellHighlight() {
      try {
        if (!this.activeEditFenceId) {
          // 如果没有选中的围栏，清除所有高亮
          this.clearStationCellHighlight();
          return;
        }

        const colIndex = (this.col || []).findIndex(c => c && c.key === 'stationName');
        if (colIndex < 0) return;

        const tableRef = this.$refs.fenceTable;
        const tableEl = tableRef && tableRef.$el;
        if (!tableEl) return;

        const tbody = tableEl.querySelector('.ivu-table-body tbody');
        if (!tbody) return;

        // 找到选中行的归属站点名称
        const list = this.displayAreaList || [];
        const activeRow = list.find(item => item.tempId === this.activeEditFenceId);
        if (!activeRow) {
          this.clearStationCellHighlight();
          return;
        }

        const activeStationName = activeRow.stationName;
        if (!activeStationName) {
          this.clearStationCellHighlight();
          return;
        }

        // 遍历所有行，为相同归属站点的单元格添加高亮
        const rows = tbody.querySelectorAll('tr');
        rows.forEach((tr, index) => {
          const tds = tr && tr.children;
          const cell = tds && tds[colIndex];
          if (!cell) return;

          // 检查该行的归属站点是否与选中行相同
          const rowData = list[index];
          if (rowData && rowData.stationName === activeStationName && cell.style.display !== 'none') {
            cell.classList.add('station-cell-active');
            // 直接设置内联样式确保生效
            cell.style.backgroundColor = 'rgba(24, 144, 255, 0.08)';
            cell.style.fontWeight = '600';
            cell.style.color = '#1890ff';
          } else {
            cell.classList.remove('station-cell-active');
            // 清除内联样式
            cell.style.backgroundColor = '';
            cell.style.fontWeight = '';
            cell.style.color = '';
          }
        });
      } catch (e) {
        console.error('更新归属站点高亮失败:', e);
      }
    },
    // 清除归属站点单元格的高亮
    clearStationCellHighlight() {
      try {
        const colIndex = (this.col || []).findIndex(c => c && c.key === 'stationName');
        if (colIndex < 0) return;

        const tableRef = this.$refs.fenceTable;
        const tableEl = tableRef && tableRef.$el;
        if (!tableEl) return;

        const tbody = tableEl.querySelector('.ivu-table-body tbody');
        if (!tbody) return;

        const rows = tbody.querySelectorAll('tr');
        rows.forEach(tr => {
          const tds = tr && tr.children;
          const cell = tds && tds[colIndex];
          if (cell) {
            cell.classList.remove('station-cell-active');
            // 清除内联样式
            cell.style.backgroundColor = '';
            cell.style.fontWeight = '';
            cell.style.color = '';
          }
        });
      } catch (e) {
      }
    },
    // 绑定表格行的 hover 事件
    bindTableRowHoverEvents() {
      try {
        const tableRef = this.$refs.fenceTable;
        const tableEl = tableRef && tableRef.$el;
        if (!tableEl) return;

        const tbody = tableEl.querySelector('.ivu-table-body tbody');
        if (!tbody) return;

        const rows = tbody.querySelectorAll('tr.ivu-table-row');
        const list = this.displayAreaList || [];
        const colIndex = (this.col || []).findIndex(c => c && c.key === 'stationName');
        if (colIndex < 0) return;

        rows.forEach((row, index) => {
          // 移除旧的事件监听器（如果存在）
          row.onmouseenter = null;
          row.onmouseleave = null;

          // 添加鼠标进入事件
          row.onmouseenter = () => {
            const rowData = list[index];
            if (!rowData || !rowData.stationName) return;

            const stationName = rowData.stationName;
            
            // 为所有相同归属站点的单元格添加 hover 样式
            rows.forEach((tr, idx) => {
              const data = list[idx];
              if (data && data.stationName === stationName) {
                const tds = tr.children;
                const cell = tds && tds[colIndex];
                if (cell && cell.style.display !== 'none' && !cell.classList.contains('station-cell-active')) {
                  cell.classList.add('station-cell-hover');
                  // 如果没有 active 样式，添加 hover 内联样式
                  if (!cell.classList.contains('station-cell-active')) {
                    cell.style.backgroundColor = 'rgba(24, 144, 255, 0.05)';
                  }
                }
              }
            });
          };

          // 添加鼠标离开事件
          row.onmouseleave = () => {
            // 清除所有 hover 样式
            rows.forEach(tr => {
              const tds = tr.children;
              const cell = tds && tds[colIndex];
              if (cell && cell.classList.contains('station-cell-hover')) {
                cell.classList.remove('station-cell-hover');
                // 如果没有 active 样式，清除背景色
                if (!cell.classList.contains('station-cell-active')) {
                  cell.style.backgroundColor = '';
                }
              }
            });
          };
        });
      } catch (e) {
        console.error('绑定表格行 hover 事件失败:', e);
      }
    },
    /**
     * 采集缓冲“拐角样式”切换时的联动处理。
     * - round：默认补一个分辨率（用于圆角近似）
     * - 非 round：清空分辨率输入（避免误导）
     */
    handleCollectJoinStyleChange(value) {
      if (value === 'round') {
        if (this.collectBufferResolution == null) this.collectBufferResolution = 16;
      } else {
        this.collectBufferResolution = null;
      }
    },
    /**
     * 解析单个“带方向”的坐标 token 为十进制度数。
     * 支持：
     * - 度分秒：30°15′12.3″N / 120°08′01.0″E
     * - 十进制+方向：30.123N / 120.456E
     * - 纯十进制：30.123
     * @throws 坐标格式不合法时抛错（用于上层统一提示）
     */
    parseDirectionalCoordinate(token) {
      const s = (token || '').trim();
      if (!s) throw new Error(langMap.coordinateFormatError[this.lang]);

      const dmsPattern = /^(\d+)°(\d+)′([\d.]+)″([NSEW])$/;
      const dmsMatch = s.match(dmsPattern);
      if (dmsMatch) {
        const degrees = parseFloat(dmsMatch[1]);
        const minutes = parseFloat(dmsMatch[2]);
        const seconds = parseFloat(dmsMatch[3]);
        const direction = dmsMatch[4];
        let dd = degrees + minutes / 60 + seconds / 3600;
        if (direction === 'S' || direction === 'W') dd = -dd;
        return dd;
      }

      const ddDirPattern = /^([\d.+-]+)([NSEW])$/;
      const ddDirMatch = s.match(ddDirPattern);
      if (ddDirMatch) {
        let dd = parseFloat(ddDirMatch[1]);
        const direction = ddDirMatch[2];
        if (Number.isNaN(dd)) throw new Error(langMap.coordinateFormatError[this.lang]);
        if (direction === 'S' || direction === 'W') dd = -dd;
        return dd;
      }

      const dd = parseFloat(s);
      if (!Number.isNaN(dd)) return dd;
      throw new Error(langMap.coordinateFormatError[this.lang]);
    },
    /**
     * 解析“采集点文本”格式为点数组。
     * - 支持空格或逗号分隔行
     * - 默认读取第 2/3 列为纬度/经度（适配常见：序号,lat,lng）
     * - 坐标列支持带方向（N/S/E/W）
     */
    parseCollectPointsText(text) {
      const raw = (text || '').trim();
      if (!raw) return [];
      const lines = raw.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
      const points = [];
      lines.forEach(line => {
        const parts = line.includes(',')
          ? line.split(',').map(p => p.trim()).filter(Boolean)
          : line.split(/\s+/).map(p => p.trim()).filter(Boolean);
        if (parts.length < 3) return;
        const lat = this.parseDirectionalCoordinate(parts[1]);
        const lng = this.parseDirectionalCoordinate(parts[2]);
        if (Number.isNaN(lat) || Number.isNaN(lng)) return;
        points.push({ lat, lng });
      });
      return points;
    },
    /**
     * 将采集输入内容统一解析为“线”的点序列（>=2 点）。
     * 优先识别 JSON（数组形式或对象形式），失败则回退为逐行文本解析。
     * 兼容字段：
     * - [lng, lat]
     * - {lat, lng}
     * - {latitude, longitude}
     */
    parseCollectImportAreaToLinePoints(value) {
      const raw = (value || '').trim();
      if (!raw) return [];
      try {
        const data = JSON.parse(raw);
        if (!Array.isArray(data)) return [];
        const points = data.map(p => {
          if (Array.isArray(p) && p.length >= 2) {
            const lng = parseFloat(p[0]);
            const lat = parseFloat(p[1]);
            return { lat, lng };
          }
          const lat = parseFloat(p && p.lat);
          const lng = parseFloat(p && p.lng);
          if (!Number.isNaN(lat) && !Number.isNaN(lng)) return { lat, lng };
          const lat2 = parseFloat(p && p.latitude);
          const lng2 = parseFloat(p && p.longitude);
          if (!Number.isNaN(lat2) && !Number.isNaN(lng2)) return { lat: lat2, lng: lng2 };
          return null;
        }).filter(Boolean);
        return points;
      } catch (e) {
        return this.parseCollectPointsText(raw);
      }
    },
    /**
     * WGS84 经纬度 -> Web Mercator（单位：米）。
     * 用于把“米”为单位的缓冲距离转换到可计算的平面坐标系中。
     */
    wgs84ToWebMercator(lat, lng) {
      const R = 6378137;
      const x = (lng * Math.PI / 180) * R;
      const y = Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI / 180) / 2)) * R;
      return { x, y };
    },
    /**
     * Web Mercator（单位：米）-> WGS84 经纬度。
     * 输出做了精度截断，避免序列化后小数噪声过大。
     */
    webMercatorToWgs84(x, y) {
      const R = 6378137;
      const lng = (x / R) * (180 / Math.PI);
      const lat = (2 * Math.atan(Math.exp(y / R)) - Math.PI / 2) * (180 / Math.PI);
      return { lat: Math.round(lat * 1e10) / 1e10, lng: Math.round(lng * 1e10) / 1e10 };
    },
    /**
     * 根据“采集线点 + 缓冲距离(米)”生成可用的围栏面，并写回到采集输入字段。
     * - 先把 WGS84 转 WebMercator，按米做 offset
     * - 使用 clipper-lib 生成 open path 的缓冲多边形
     * - 多个结果时取面积最大的一个作为最终围栏
     */
    generateCollectAreaFromPoints() {
      let linePoints;
      try {
        linePoints = this.parseCollectImportAreaToLinePoints(this.saveForm.collectImportArea);
      } catch (e) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: (e && e.message) || langMap.coordinateFormatError[this.lang]
        });
        return;
      }

      if (!Array.isArray(linePoints) || linePoints.length < 2) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.collectDataRequired[this.lang]
        });
        return;
      }

      const distanceM = parseFloat(this.collectBufferDistanceM);
      if (Number.isNaN(distanceM) || distanceM <= 0) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.invalidExpandDistance[this.lang]
        });
        return;
      }

      const joinStyle = this.collectBufferJoinStyle === 'round' ? 'round' : 'miter';
      const resolution = joinStyle === 'round' ? Math.max(4, parseInt(this.collectBufferResolution, 10) || 16) : 16;

      const mercator = linePoints.map(p => this.wgs84ToWebMercator(p.lat, p.lng));
      const scale = 1000;
      const path = mercator.map(p => ({ X: Math.round(p.x * scale), Y: Math.round(p.y * scale) }));
      const delta = Math.round(distanceM * scale);

      const miterLimit = 2.0;
      const arcTolerance = joinStyle === 'round' ? Math.max(0.1, (distanceM * scale) / resolution) : 0.1;
      const co = new ClipperLib.ClipperOffset(miterLimit, arcTolerance);
      const jt = joinStyle === 'round' ? ClipperLib.JoinType.jtRound : ClipperLib.JoinType.jtSquare;
      const endType = joinStyle === 'round' ? ClipperLib.EndType.etOpenRound : ClipperLib.EndType.etOpenSquare;
      co.AddPath(path, jt, endType);
      const solution = [];
      co.Execute(solution, delta);

      if (!solution || solution.length === 0) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.generateAreaFailed[this.lang]
        });
        return;
      }

      let best = solution[0];
      let bestArea = Math.abs(ClipperLib.Clipper.Area(best));
      for (let i = 1; i < solution.length; i++) {
        const area = Math.abs(ClipperLib.Clipper.Area(solution[i]));
        if (area > bestArea) {
          best = solution[i];
          bestArea = area;
        }
      }

      const polygonLatLngs = best.map(pt => this.webMercatorToWgs84(pt.X / scale, pt.Y / scale));
      const cleaned = polygonLatLngs.filter(p => !Number.isNaN(p.lat) && !Number.isNaN(p.lng));
      if (cleaned.length < 3) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.collectionDataRequired[this.lang]
        });
        return;
      }

      this.saveForm.collectImportArea = JSON.stringify(cleaned);
      this.$Message.success(langMap.importSuccess[this.lang]);
      
      // 生成数据后进行校验
      this.$nextTick(() => {
        if (this.$refs.formValidate) {
          this.$refs.formValidate.validateField('collectImportArea');
        }
      });
    },
    // 接收子组件数据
    updateAreaList(areaList) {
      if (!Array.isArray(areaList)) return;
      const current = Array.isArray(this.areaList) ? this.areaList : [];
      const currentById = new Map();
      current.forEach(item => {
        const key = item && item.tempId != null ? item.tempId : (item && item.id != null ? item.id : null);
        if (key != null) currentById.set(key, item);
      });

      const nextById = new Map();
      areaList.forEach(item => {
        const key = item && item.tempId != null ? item.tempId : (item && item.id != null ? item.id : null);
        if (key != null) nextById.set(key, item);
      });

      const merged = current.map(item => {
        const key = item && item.tempId != null ? item.tempId : (item && item.id != null ? item.id : null);
        if (key != null && nextById.has(key)) {
          return { ...item, ...nextById.get(key) };
        }
        return item;
      });

      nextById.forEach((value, key) => {
        if (!currentById.has(key)) merged.push(value);
      });

      this.areaList = merged;
    },
    // 接收子组件“围栏渲染完成”事件并更新加载状态
    handleAreasRendered() {
      this.fencesRendered = true;
      this.isRerenderingFence = false;
      this.isCollectPreviewRendering = false;
    },
    // 接收子组件“围栏开始渲染”事件并更新加载状态
    handleAreasRenderStart(scene) {
      this.fencesRendered = false;
      this.isRerenderingFence = true;
      this.isCollectPreviewRendering = scene === 'collectPreview';
    },
    //初始化地图
    async initMap() {
      mapCase = this.$refs.mapCase;
      await mapCase.initMap();
      this.$nextTick(() => this.mapLoading = false);
      console.log('[地图加载完毕]');
      this.loadAreas();
    },
    //加载现有区域
    loadAreas(callback,clearEditFenceId) {
      this.tableLoading = true;
      this.fencesRendered = false;
      this.tableRendered = false;

      api.getData("task-server/fence/list", this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            const list = (res.data || []).map(item => {
              const nextItem = { ...item, tempId: item.id };
              this.areaTypeList.forEach(typeItem => {
                if (typeItem.id === nextItem.type) {
                  nextItem.typeStr = typeItem.name;
                }
              });
              return nextItem;
            });
            this.areaList = list;
          }

          if (clearEditFenceId) {
            this.activeEditFenceId = null;
          }

          if (mapCase && mapCase.loadAreas) {
            mapCase.loadAreas(this.areaList, this.activeEditFenceId);
          }

          if (this.areaList && this.areaList.length > 0) {
            try {
              const area1 = this.areaList[0] && this.areaList[0].area ? JSON.parse(this.areaList[0].area) : null;
              const _point = area1 && area1.length ? area1[0] : null;
              if (_point && mapCase && mapCase.moveToCenter) {
                mapCase.moveToCenter([parseFloat(_point.lon), parseFloat(_point.lat)]);
              }
            } catch (e) {
            }
          }

          callback && callback();
        })
        .catch(() => {
          this.fencesRendered = true;
        })
        .finally(() => {
          this.tableLoading = false;
          this.$nextTick(() => {
            this.tableRendered = true;
            this.$nextTick(() => {
              this.mergeStationNameCells();
            });
            if (this.defaultMap !== 'leaflet' && !this.fencesRendered) {
              this.fencesRendered = true;
            }
          });
        });
    },
    // 获取归属点（基站）列表
    getStationList() {
      api.getData('task-server/robotStation/list/all', this).then((res) => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg,
          });
        } else {
          if (res.data) {
            this.stationList = res.data || [];
          }
        }
      })
    },
    //更新区域
    updateArea(layer) {
      mapCase.updateArea(layer);
    },
    //绘制区域
    drawFence(row) {
      mapCase.drawFence(row);
    },
    //打开编辑
    editFence() {
      this.setEditMode(!this.isEdit);
    },
    // 设置编辑模式开关，并同步到地图组件
    setEditMode(isEdit) {
      const next = !!isEdit;
      if (this.isEdit === next) return;
      this.isEdit = next;
      mapCase.editFence(this.isEdit);
    },

    //点击弹出信息框
    rowClick(data) {
      if (data && data.isDraft) {
        if (this.hasUnsavedMapChanges) {
          this.$Notice.warning({
            title: langMap.tip[this.lang],
            desc: langMap.pleaseFinishCurrentEdit[this.lang]
          });
          return;
        }
        this.activeEditFenceId = data.tempId;
        if (mapCase && mapCase.selectCollectPreview) {
          mapCase.selectCollectPreview(true);
        }
        this.$nextTick(() => {
          this.scrollToActiveFence(this.activeEditFenceId);
          this.updateStationCellHighlight();
        });
        return;
      }
      if (this.collectPreviewHasUnsavedChanges && this.collectPreview && this.collectPreview.active) {
        this.$Notice.warning({
          title: langMap.tip[this.lang],
          desc: langMap.pleaseFinishCurrentEdit[this.lang]
        });
        return;
      }
      if(!data.area){
        this.$Notice.warning({
          title: langMap.tip[this.lang],
          desc: langMap.pleaseDrawFence[this.lang]
        });
        return;
      }
      this.activeEditFenceId = data.tempId;
      this.createPopup(data.tempId);
      this.$nextTick(() => {
        this.updateStationCellHighlight();
      });
    },

    // 触发地图组件弹出围栏信息窗口
    createPopup(tempId) {
      mapCase.createPopup(tempId);
    },

    // 打卡新增或编辑
    modelShow(flag, data) {
      // 清除表单验证状态
      if (this.$refs.formValidate) {
        this.$refs.formValidate.resetFields();
      }
      if (data) {
        this.saveForm = { ...data };
        if (this.collectPreview.active) {
          this.cancelCollectPreview(false);
        }
      } else {
        this.saveForm = initSaveForm();
      }
      this.showGenerateAreaPanel = false;

      this.$nextTick(() => {
        this.btnLoading = false;
        this.saveModal = flag;
      });

    },
    // 是否采集改动后触发
    fillChange(val) {
      this.saveForm.isCollectImport = val === this.langMap.yes[this.lang] ? true : false;
    },
    // 选择文件后触发
    fileChange(files) {
      readJsonFile(files[0]).then(res => {
        this.saveForm.collectImportArea = res;
      });
    },
    // 打开“采集草稿”编辑弹窗
    showCollectDraftForm() {
      this.$nextTick(() => {
        this.btnLoading = false;
        this.saveModal = true;
      });
    },
    /**
     * 解析采集点文本(JSON)，并生成“采集预览围栏”图层。
     * - 输入为 WGS84 时：优先批量转换到 GCJ02 用于地图展示；失败则回退使用原坐标预览
     * - 开启采集预览后：自动进入编辑模式并选中该预览围栏，便于继续调整/保存
     */
    async previewCollectFence() {
      if (this.collectPreviewEditingLocked) return;
      let points;
      try {
        points = JSON.parse(this.saveForm.collectImportArea || '');
      } catch (e) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.jsonFormatError[this.lang]
        });
        return;
      }
      if (!Array.isArray(points) || points.length < 3) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.collectionDataRequired[this.lang]
        });
        return;
      }
      const normalized = points.map(p => ({
        lat: parseFloat(p.lat),
        lng: parseFloat(p.lng)
      })).filter(p => !Number.isNaN(p.lat) && !Number.isNaN(p.lng));

      if (normalized.length < 3) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.collectionDataRequired[this.lang]
        });
        return;
      }

      this.saveModal = false;
      await new Promise(resolve => this.$nextTick(resolve));
      const raf = (typeof window !== 'undefined' && window.requestAnimationFrame) ? window.requestAnimationFrame : (fn) => setTimeout(fn, 0);
      await new Promise(resolve => raf(resolve));
      this.handleAreasRenderStart('collectPreview');

      let allConverted = true;
      const previewLatLngs = [];
      const batchInput = normalized.map(p => [parseFloat(p.lng), parseFloat(p.lat)]);
      if (batchInput.some(pair => pair.some(v => Number.isNaN(v)))) {
        allConverted = false;
      } else {
        try {
          const res = await api.postData(
            `task-server/coordinate/batchWgs84ToGcj02`,
            batchInput,
            this
          );
          const data = (res && res.success && Array.isArray(res.data)) ? res.data : ((res && res.state != 0 && Array.isArray(res.data)) ? res.data : null);
          if (!data || data.length !== batchInput.length) {
            allConverted = false;
          } else {
            const converted = data.map(pair => {
              const lng = Array.isArray(pair) ? parseFloat(pair[0]) : NaN;
              const lat = Array.isArray(pair) ? parseFloat(pair[1]) : NaN;
              return { lng, lat };
            });
            if (converted.some(p => Number.isNaN(p.lat) || Number.isNaN(p.lng))) {
              allConverted = false;
            } else {
              previewLatLngs.push(...converted);
            }
          }
        } catch (e) {
          allConverted = false;
        }
      }

      const finalLatLngs = allConverted ? previewLatLngs : normalized.map(p => ({ lat: p.lat, lng: p.lng }));
      if (!this.collectPreview.active) {
        this.collectPreviewEntryIsEdit = this.isEdit;
      }
      this.collectPreview.active = true;
      this.collectPreview.latlngs = finalLatLngs;
      this.collectPreviewStableLatLngs = JSON.parse(JSON.stringify(finalLatLngs));
      this.collectPreviewStableImportArea = this.saveForm.collectImportArea || '';
      this.collectPreviewHasUnsavedChanges = false;
      this.activeEditFenceId = this.collectPreview.id;

      this.setEditMode(true);
      if (mapCase && mapCase.selectCollectPreview) {
        this.$nextTick(() => {
          mapCase.selectCollectPreview(true);
        });
      }
      this.$nextTick(() => {
        this.scrollToActiveFence(this.activeEditFenceId);
      });
    },
    // 取消采集预览并恢复进入预览前的编辑模式（可选）
    cancelCollectPreview(restoreMode = true) {
      this.collectPreview.active = false;
      this.collectPreview.latlngs = [];
      this.collectPreviewHasUnsavedChanges = false;
      this.collectPreviewStableLatLngs = [];
      this.collectPreviewStableImportArea = '';
      const entry = this.collectPreviewEntryIsEdit;
      this.collectPreviewEntryIsEdit = null;
      if (restoreMode && typeof entry === 'boolean') {
        this.setEditMode(entry);
      }
    },
    // 处理采集预览围栏在地图上的编辑回传，并同步到表单输入
    async handleCollectPreviewEdited(payload) {
      if (!payload || !Array.isArray(payload.latlngs) || !Array.isArray(payload.oldLatlngs)) return;
      if (this.collectPreviewEditingLocked) return;
      this.collectPreviewEditingLocked = true;

      const prevCollectImportArea = this.saveForm.collectImportArea;
      try {
        const batchInput = payload.latlngs.map(p => [parseFloat(p.lng), parseFloat(p.lat)]);
        if (batchInput.some(pair => pair.some(v => Number.isNaN(v)))) {
          throw new Error(langMap.coordinateConversionFailed[this.lang]);
        }

        const res = await api.postData(
          `task-server/coordinate/batchGcj02ToWgs84`,
          batchInput,
          this
        );

        if (!res || res.state == 0) {
          throw new Error((res && res.msg) || langMap.coordinateConversionFailed[this.lang]);
        }

        const data = (res && res.data) ? res.data : null;
        if (!Array.isArray(data) || data.length !== batchInput.length) {
          throw new Error(langMap.coordinateConversionFailed[this.lang]);
        }

        const wgsPoints = data.map(pair => {
          const lng = Array.isArray(pair) ? parseFloat(pair[0]) : NaN;
          const lat = Array.isArray(pair) ? parseFloat(pair[1]) : NaN;
          return { lng, lat };
        });
        if (wgsPoints.some(p => Number.isNaN(p.lat) || Number.isNaN(p.lng))) {
          throw new Error(langMap.coordinateConversionFailed[this.lang]);
        }

        const text = JSON.stringify(wgsPoints);
        this.saveForm.collectImportArea = text;
        this.saveForm.isCollectImport = true;
        this.saveForm._isFill = this.langMap.yes[this.lang];

        this.collectPreview.latlngs = payload.latlngs;
        this.collectPreviewHasUnsavedChanges = true;
      } catch (e) {
        this.saveForm.collectImportArea = prevCollectImportArea;
        this.collectPreview.latlngs = payload.oldLatlngs;
        if (mapCase && mapCase.restoreCollectPreviewLatLngs) {
          mapCase.restoreCollectPreviewLatLngs(payload.oldLatlngs);
        }
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: (e && e.message) || langMap.coordinateConversionFailed[this.lang]
        });
      } finally {
        this.collectPreviewEditingLocked = false;
      }
    },
    // 从地图侧保存采集预览为新围栏（走表单校验与 saveOne）
    saveCollectPreviewFromMap() {
      if (this.collectPreviewEditingLocked) return;
      if (!this.collectPreview.active) return;
      if (this.hasUnsavedMapChanges) return;
      if (!this.$refs.formValidate || !this.$refs.formValidate.validate) {
        return;
      }
      this.$refs.formValidate.validate(valid => {
        if (!valid) {
          this.saveModal = true;
          return;
        }
        let data = { ...this.saveForm };
        data.id = null;
        data.tempId = null;
        if (data.collectImportArea) {
          let _d = data.collectImportArea.replace(/\r/g, '').replace(/\n/g, '').replace(/\t/g, '').replace(' ', '').replace(/\s/g, '');
          data.collectImportArea = _d;
        }
        this.btnLoading = true;
        this.saveOne(data, true, (success) => {
          this.btnLoading = false;
          if (success) {
            this.cancelCollectPreview();
          }
        });
      });
    },
    // 取消采集预览在地图上的未保存编辑（回滚到稳定快照）
    cancelCollectPreviewEditsFromMap() {
      if (!this.collectPreview.active) return;
      if (!this.collectPreviewHasUnsavedChanges) return;
      const stableLatlngs = JSON.parse(JSON.stringify(this.collectPreviewStableLatLngs || []));
      this.collectPreview.latlngs = stableLatlngs;
      this.saveForm.collectImportArea = this.collectPreviewStableImportArea;
      this.collectPreviewHasUnsavedChanges = false;
      if (mapCase && mapCase.restoreCollectPreviewLatLngs) {
        mapCase.restoreCollectPreviewLatLngs(stableLatlngs);
      }
    },
    //保存（新增或编辑）
    save() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          let data = { ...this.saveForm };
          if (data.collectImportArea) {
            let _d = data.collectImportArea.replace(/\r/g, '').replace(/\n/g, '').replace(/\t/g, '').replace(' ', '').replace(/\s/g, '');
            data.collectImportArea = _d;
          }

          this.btnLoading = true;
          this.saveOne(data, true, (success) => {
            if (success) {
              this.saveModal = false;
              if (this.collectPreview.active) {
                this.cancelCollectPreview();
              }
            } else {
              this.saveModal = true;
            }
          });
        }
      });
    },
    // 保存单条围栏数据（新增/更新），并在成功后刷新列表
    saveOne(formData, hasMsg,callback) {
      this.btnLoading = true;
      api.postData("task-server/fence/saveOne", formData, this).then(res => {
        this.btnLoading = false;
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.promptFromSystem[this.lang],
            desc: res.msg
          });
          callback && callback(false);
        } else {
          if (hasMsg) {
            this.$Notice.success({
              title: langMap.promptFromSystem[this.lang],
              desc: langMap.operationSuccess[this.lang]
            });
          }
          //保存成功，刷新当前页面
          this.activeEditFenceId = formData.id
          this.loadAreas(this.initActiveFocus);
          callback && callback(true);
        }
      });
    },
    // 关闭新增/编辑弹窗
    cancel() {
      this.saveModal = false;
    },
    //重新获得焦点控制
    initActiveFocus(initStatus){
      if(initStatus){
        this.activeEditFenceId = null
        mapCase.editFence(false);
        mapCase.editFence(true);
      }else if(this.activeEditFenceId){
        this.createPopup(this.activeEditFenceId);
      }else if(this.isEdit){
        mapCase.disableAllFencesEdit()
      }
    },
    //校验
    checkArea() {
      let check = true;
      let hasSetArea = true;
      this.areaList.forEach((item, index, arr) => {
        if (item.area === null) {
          hasSetArea = false;
        }
      });
      if (!hasSetArea) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.electronicFenceLackingMapAreaSetting[this.lang]
        });
        check = false;
      }
      return check;
    },
    // 获取围栏类型等字典数据（用于类型下拉/列表展示）
    getDic() {
      api.getData("task-server/path/get/dic", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.areaTypeList = res.data.areaType;
        }
      });
    },
    // 复制文本到剪贴板并给出提示
    copyToClipboard(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$Notice.success({
        title: langMap.tip[this.lang],
        desc: langMap.copySuccess[this.lang]
      });
    },
    // 添加处理刷新数据的方法
    handleRefreshData() {
      // 直接调用现有的loadAreas方法刷新数据
      this.loadAreas(this.initActiveFocus);
    },
    // 修改处理激活围栏变化的方法，添加滚动定位功能
    handleActiveFenceChanged(fenceId) {
      this.activeEditFenceId = fenceId;

      // 如果有选中的围栏，进行表格滚动定位
      if (fenceId) {
        this.$nextTick(() => {
          this.scrollToActiveFence(fenceId);
          this.updateStationCellHighlight();
        });
      } else {
        this.$nextTick(() => {
          this.clearStationCellHighlight();
        });
      }
    },

    // 添加滚动到激活围栏的方法
    scrollToActiveFence(fenceId) {
      // 先找到当前选中的围栏在数据中的索引
      const list = this.displayAreaList || [];
      const index = list.findIndex(item => item.tempId === fenceId);

      if (index === -1) return; // 如果找不到，直接返回

      try {
        // 获取表格DOM元素
        const tableEl = this.$refs.fenceTable.$el;
        if (!tableEl) return;

        // 获取表格体
        const tbody = tableEl.querySelector('.ivu-table-body');
        if (!tbody) return;

        // 获取所有行
        const rows = tbody.querySelectorAll('tr.ivu-table-row');
        if (!rows || !rows[index]) return;

        // 计算需要滚动的位置
        const targetRow = rows[index];
        const rowTop = targetRow.offsetTop;
        const rowHeight = targetRow.offsetHeight;
        const scrollTop = tbody.scrollTop;
        const visibleHeight = tbody.clientHeight;

        // 判断目标行是否在可视区域内
        if (rowTop < scrollTop || rowTop + rowHeight > scrollTop + visibleHeight) {
          // 如果不在可视区域，滚动到让目标行居中的位置
          const newScrollTop = rowTop - (visibleHeight / 2) + (rowHeight / 2);

          // 平滑滚动到目标位置
          this.smoothScrollTo(tbody, newScrollTop);
        }
      } catch (e) {
        console.error('滚动到激活围栏失败:', e);
      }
    },

    // 添加平滑滚动方法
    smoothScrollTo(element, to, duration = 300) {
      const start = element.scrollTop;
      const change = to - start;
      let currentTime = 0;
      const increment = 20;

      const animateScroll = () => {
        currentTime += increment;
        const val = this.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };

      animateScroll();
    },

    // 添加缓动函数，使滚动更自然
    easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    },

    // 添加行类名的方法
    rowClassName(row) {
      if (row.tempId === this.activeEditFenceId) {
        return 'row-active-edit';
      }
      return '';
    },
    // 处理未保存更改状态变化
    handleUnsavedChangesChanged(hasUnsavedChanges) {
      this.hasUnsavedMapChanges = hasUnsavedChanges;
    }
  },
  mounted() {
    this.getDic();
    this.getStationList();
    //初始化地图、初始化地图组件
    this.$nextTick(this.initMap)
  }
};
</script>
<style scoped>
.articlemanagement{
  position: relative;
}
.leaflet {
  width: 100%;
  height: 100%;
}

.nodeArea {
  width: 100%;
  height: 500px;
}

.map {
  width: 100%;
  height: calc(100%);
  z-index: 1;
}

.input-item {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  height: 3rem;
}

.input-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 0.25rem;
  width: 22rem;
  border-width: 0;
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 0.75rem 1.25rem;
  font-size: 12px;
}

.custom-input-card {
  width: 18rem;
}

.custom-input-card .btn:last-child {
  margin-left: 1rem;
}

.content-window-card {
  position: relative;
  width: 23rem;
  padding: 0.75rem 0 0 1.25rem;
  box-shadow: none;
  bottom: 0;
  left: 0;
}

.content-window-card p {
  height: 2rem;
}

#myPageTop {
  position: absolute;
  top: 5px;
  right: 10px;
  background: #fff none repeat scroll 0 0;
  border: 1px solid #ccc;
  margin: 10px auto;
  padding: 6px;
  font-family: "Microsoft Yahei", "微软雅黑", "Pinghei";
  font-size: 14px;
  z-index: 10;
}

#myPageTop label {
  margin: 0 20px 0 0;
  color: #666666;
  font-weight: normal;
}

#myPageTop input {
  width: 170px;
}

#myPageTop .column2 {
  padding-left: 25px;
}

.des-cardTittle-box {
  display: flex;
  justify-content: space-between;
}

.copy-area-container {
  position: relative;
}

.copy-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
}
/* 确保文本区域可以正常滚动 */
.scrollable-textarea {
  height: auto !important;
  max-height: none !important;
}

.scrollable-textarea >>> .ivu-input {
  height: 100px !important; /* 固定高度 */
  overflow-y: auto !important; /* 确保垂直滚动条显示 */
  resize: none; /* 禁止用户调整大小 */
}

/* 添加选中行的样式 - 优化蓝色系版本 */
/deep/ .row-active-edit {
  background-color: rgba(24, 144, 255, 0.08) !important;
  border-left: 4px solid #1890ff !important;
  transition: all 0.3s ease;
}

/deep/ .row-active-edit td {
  background-color: rgba(24, 144, 255, 0.08) !important;
  font-weight: 600;
  color: #1890ff;
  transition: all 0.2s ease;
}

/deep/ .row-active-edit:hover td {
  background-color: rgba(24, 144, 255, 0.15) !important;
}

/* 添加选中行按钮的特殊样式 */
/deep/ .row-active-edit .ivu-btn-text {
  color: #1890ff;
  font-weight: 500;
}

/* 添加动画效果 */
/deep/ .row-active-edit {
  animation: pulse-blue 2s infinite;
}

@keyframes pulse-blue {
  0% {
    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.1);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(24, 144, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);
  }
}

/* 为归属站点列添加高亮样式类 - 增强优先级 */
/deep/ td.station-cell-active,
/deep/ .ivu-table-cell.station-cell-active,
/deep/ .station-cell-active {
  background-color: rgb(63 154 249 / 20%) !important;
  font-weight: 600 !important;
  color: #1890ff !important;
  transition: all 0.2s ease !important;
}

/* 为归属站点列添加 hover 高亮样式类 - 增强优先级 */
/deep/ td.station-cell-hover,
/deep/ .ivu-table-cell.station-cell-hover,
/deep/ .station-cell-hover {
  background-color: rgba(24, 144, 255, 0.05) !important;
  transition: all 0.2s ease !important;
}

/* 3行省略号样式 - 使用深度选择器 */
/deep/ .text-ellipsis-3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  max-height: 4.2em; /* 3行 * 1.4行高 */
  word-break: break-word;
  cursor: pointer;
}
/deep/ .ivu-table-cell{
  padding-left: 10px;
  padding-right: 10px;
}

/deep/ .fence-edit-modal .ivu-modal-body {
  height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.demo-spin-icon-load {
  animation: demo-spin 1s linear infinite;
}

/* iView Spin fix 内置 z-index 只有 8，低于地图面板（1000），需覆盖确保遮罩置顶 */
/deep/ .ivu-spin-fix {
  z-index: 1100 !important;
}

@keyframes demo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
